import React from "react";
import { useSiteMetadata } from "../hooks/use-site-metadata";

export const SearchEngineOptimisation = ({
  title,
  description,
  pathname,
  children,
  image,
  writer,
  writerUrl,
  datePublished,
  headline,
  blogPost,
  organisation,
  webPage,
}) => {
  const {
    title: defaultTitle,
    description: defaultDescription,
    image: defaultImage,
    siteUrl,
    twitterUsername,
  } = useSiteMetadata();

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image: image || defaultImage,
    url: `${siteUrl}${pathname || ``}`,
    twitterUsername,
  };

  let schemaOrgJSONLD = [
    {
      "@context": "http://schema.org",
      "@type": "WebSite",
      "@id": siteUrl,
      url: siteUrl,
      name: "Novacom | Award Winning Digital Marketing Agency",
    },
  ];
  if (blogPost) {
    schemaOrgJSONLD = [
      {
        "@context": "http://schema.org",
        "@type": "BlogPosting",
        "@id": `${pathname || ``}`,
        url: `${siteUrl}${pathname || ``}`,
        name: title,
        headline: headline,
        image: {
          "@type": "ImageObject",
          url: seo.image,
        },
        description: description,
        datePublished: datePublished,
        // dateModified: buildTime,
        author: {
          "@type": "Person",
          name: writer,
          url: writerUrl,
        },
        publisher: {
          "@type": "Organization",
          name: "Novacom",
          logo: {
            "@type": "ImageObject",
            url: defaultImage,
          },
        },
      },
    ];
  }
  if (organisation) {
    schemaOrgJSONLD = [
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: "Novacom | Award Winning Digital Marketing Agency",
        url: siteUrl,
        description:
          "Novacom is an award-winning digital marketing agency, offering brands a full-service digital solution.",
        logo: "https://novacom.group/gatsby/wp-content/uploads/2026/02/favicon.svg",
        contactPoint: {
          "@type": "ContactPoint",
          telephone: "+44 (0)1799 599 966",
          email: "enquiries.uk@novacom.group",
        },
        address: [
          {
            "@type": "PostalAddress",
            streetAddress: "The Old Granary",
            addressLocality: "Cambridge",
            postalCode: "CB10 2ET",
            addressCountry: "UK",
          },
          {
            streetAddress: "Herengracht 280",
            addressLocality: "Amsterdam",
            postalCode: "1016 BX",
            addressCountry: "NL",
          },
          {
            streetAddress: "111 Somerset Road #08-10A, 111 Somerset",
            addressLocality: "Singapore",
            postalCode: "238164",
            addressCountry: "SG",
          },
          {
            streetAddress: "315 Montgomery Street",
            addressLocality: "San Francisco",
            postalCode: "CA 94104",
            addressCountry: "US",
          },
          {
            streetAddress: "280 Madison Avenue Suite 912, 9th Floor",
            addressLocality: "New York",
            postalCode: "NY 10016",
            addressCountry: "US",
          },
          {
            streetAddress: "Office 2501, 25th Floor Burj Al Salam, Sheikh Zayed Road",
            addressLocality: "Dubai",
            postalCode: "PO Box 73310",
            addressCountry: "AE",
          },
        ],
        sameAs: [
          "https://www.linkedin.com/company/novacomcorp",
          "https://www.youtube.com/user/novacomcorp",
          "https://www.facebook.com/novacomcorp",
          "https://www.instagram.com/novacomcorp",
        ],
      },
    ];
  }
  // if (webPage) {
  //   schemaOrgJSONLD = [
  //     {
  //       "@context": "http://schema.org",
  //       "@type": "WebPage",
  //       "@id": `${pathname || ``}`,
  //       url: `${siteUrl}${pathname || ``}`,
  //       name: title,
  //       headline: title,
  //       image: {
  //         "@type": "ImageObject",
  //         url: seo.image,
  //       },
  //       description: description,
  //       publisher: {
  //         "@type": "Organization",
  //         name: "Novacom",
  //         logo: {
  //           "@type": "ImageObject",
  //           url: defaultImage,
  //         },
  //       },
  //     },
  //   ];
  // }

  return (
    <>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      {/* Favicons */}
      <link rel="icon" type="image/svg+xml" href="/favicon.svg" />
      <link rel="alt icon" href="/favicon.ico" />
      <script type="application/ld+json">
        {JSON.stringify(schemaOrgJSONLD)}
      </script>
      {children}

      {/* Google Tag Manager */}
      <script type="text/javascript">
        {` (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-KRZPCG3'); `}
      </script>
    </>
  );
};
